import ActionTypes, { PropertyStatus } from './types';
import { PropertyAction } from './actions';
import { Property } from './types';
import { ApplicantType } from '../invitation';

export interface PropertyState {
  property: Property;
  status: PropertyStatus;
}

export const initialState: () => PropertyState = () => {
  return {
    status: 'not_load',
    property: {
      contractInfoId: '',
      usageInfoId: '',
      usageId: '',
      allSpaceId: '',
      contractId: '',
      hasElectricContract: true,
      occupyScheduledDate: new Date(),
      postCode: '',
      address: '',
      prefecture: '',
      city: '',
      afterCity: '',
      buildingName: '',
      propertyName: '',
      propertyCode: '',
      sumamoruCode: '',
      managementCompanyAddress: '',
      managementCompanyName: '',
      managementCompanyPhoneNumber: '',
      sumamoruInstallAppTypes: [],
      sumamoruAdditionalServices: [],
      applicantType: ApplicantType.ContractorAndOccupant
    }
  };
};

const reducer = (state: PropertyState = initialState(), action: PropertyAction): PropertyState => {
  switch (action.type) {
    case ActionTypes.startToFetchProperty: {
      const newState = { ...state };
      newState.status = 'property_loading';
      return newState;
    }
    case ActionTypes.setProperty: {
      const newState = { ...state };
      newState.property = action.payload;
      newState.status = 'set';
      return newState;
    }
    case ActionTypes.failedSetProperty: {
      const newState = { ...state };
      newState.status = 'error';
      return newState;
    }
    case ActionTypes.setContractInfoId: {
      return {
        ...state,
        property: { ...state.property, contractInfoId: action.payload }
      };
    }
    case ActionTypes.setUsageInfoId: {
      return {
        ...state,
        property: { ...state.property, usageInfoId: action.payload }
      };
    }
    case ActionTypes.setOrganizationId: {
      return {
        ...state,
        property: { ...state.property, organizationId: action.payload }
      };
    }
    case ActionTypes.setPeopleId: {
      return {
        ...state,
        property: { ...state.property, peopleId: action.payload }
      };
    }
    default:
      ((_: never) => {
        return;
      })(action);
      return state;
  }
};

export default reducer;
